export const locale = {
  lang: 'nl',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'FOCUS':{
      'GRUPOS':{
       'ADMIN': 'Groepsmanager',
       'CREAR': 'Creëer groep',
       'EDITAR': 'Edit group',
       'APLICAR': 'Aanvragen',
       'Naam': 'Groepsnaam',
       'BESCHRIJVING': 'Beschrijving',
       'FILTROS': 'Filters',
       'ACCION': 'Acties',
       'EDIT': 'Edit',
       'DELETE': 'Delete',
     },
     'CREAR': {
       'DATO': 'Groepsgegevens',
       'Naam': 'Groepsnaam',
       'BESCHRIJVING': 'Groepsbeschrijving',
       'FILTROS': 'Filters',
       'FILSELEC': 'Geselecteerde filters',
       'LAND': 'Land',
       'CARGO': 'Positie of functie',
       'ANTIG': 'Oudheid',
       'GENDER': 'Geslacht',
     },
      'REACTIVOS': {
        'SIN': 'U hebt de selectie van de verklaringen nog niet gedaan',
        'STEPS': {
          '1': {
              'TITULO': 'Verklaringen selectie',
              'DISPONIBLES': 'Beschikbare sjablonen:',
              'LISTADO': {
                'TITULO': 'Selecteer de overzichten voor een lijst die u wilt dat de enquête wordt opgebouwd',
                'SUBTITULO': 'Kies een sjabloon uit de lijst om de verklaringslijst te tonen',
                'PICKEDTITU': 'Verklaring lijst voor sjabloon: ',
                'PICKEDTOT': 'Beschikbare verklaringen: ',
                'PICKEDNUM': 'Gekozen verklaringen: ',
              }
          },
          '2': {
              'TITULO': 'Vertalingen'
          },
          '3': {
              'TITULO': 'Preview',
              'TEXTOS': {
                'es': {
                  'EMPRESA': 'Responde pensando en tu empresa y en todos los líderes',
                  'AREA': 'Responde pensando en tu área de trabajo y tu líder directo',
                  'BOTONES': {
                    '0': 'Casi siempre es falso',
                    '1': 'Frecuentemente es falso',
                    '2': 'A veces es falso / A veces es verdad',
                    '3': 'Frecuentemente es verdad',
                    '4': 'Casi siempre es verdad'
                  }
                },
                'en': {
                  'EMPRESA': 'Organization Perspective',
                  'AREA': 'Workgroup Perspective',
                  'BOTONES': {
                    '0': 'It is almost always false',
                    '1': 'It is often false',
                    '2': 'Sometimes it´s fake / Sometimes it´s true',
                    '3': 'It is often true',
                    '4': 'It is almost always true'
                  }
                },
                'pt': {
                  'EMPRESA': 'Perspectiva da organização',
                  'AREA': 'Perspectiva do grupo de trabalho',
                  'BOTONES': {
                    '0': 'Quase sempre é falso',
                    '1': 'É frequentemente falso',
                    '2': 'Às vezes é falso / às vezes é verdade',
                    '3': 'É frequentemente verdade',
                    '4': 'Quase sempre é verdade'
                  }
                },
              }
            }
        }
      }
    },
    'CERTIFICAR': {
      'TITUTEST': 'ASDGF',
      'IDIOMAS': {
        'ELEGIR': 'Kies',
        'STATUS': {
          'PEND': 'Volledige stap',
          'DONE': 'Stap voltooid',
          'LOCK': 'Heropen stap',
          'UNLOCK': 'Stap in het proces',
        },
        'MENSAJES':{
          'ADDLANG': 'U hebt gekozen',
          'NOADITIONAAL': 'U hebt ervoor gekozen geen extra talen in te stellen',
          'ERRORADD': 'Een fout bij het kiezen van de taal',
          'LANGDEL': 'Je hebt verwijderd',
          'NOADITIONALDEL': 'U hebt de optie om geen extra talen in te stellen, geannuleerd',
          'ERRORDEL': 'Een fout is gemaakt bij het verwijderen van de taal',
          'MAINPICKED': 'U hebt de hoofdtaal van de enquête al gekozen.<br><br>Om deze te wijzigen, verwijdert u de geselecteerde taal en kiest u een nieuwe.'
        },
        'CARD1': {
          'TITULO': 'Hoofdtaal',
          'ACCION': {
            'PRE': 'U hebt de hoofdtaal niet gekozen',
            'POST': 'U hebt de taal gekozen:',
          },
          'MODAL': {
            'TITULO': 'Kies de hoofdtaal',
            'ACCION': 'Welke taal is de hoofdtaal van het onderzoek?',
            'PLACELISTA': 'Kies een taal',
            'BOTONES': {
              'BACK': 'ACHTERGROND',
              'OK': 'Klaar',
            }
          }
        },
        'CARD2': {
          'TITULO': 'Extra talen',
          'ACCION': {
            'PRE': 'U hebt geen andere talen geselecteerd',
            'SINADIC': 'De enquête zal geen extra talen bevatten',
            'POST': 'U hebt de volgende talen geselecteerd:',
          },
          'MODAL': {
            'TITULO': 'Kies extra talen',
            'ACCION': 'Welke talen wilt u toevoegen aan de enquête?',
            'BOTONES': {
              'BACK': 'ACHTERGROND',
              'OK': 'Klaar',
            }
          }
        }
      },
      'NPS': {
        'CONFIGURE_QUESTION': 'Druk hier om de NPS weer te geven',
        'ADD': 'Maak een statement',
        'QUESTIONUPDATEDOK': 'NPS succesvol bijgewerkt',
        'STATUS': {
          'PEND': 'Volledige stap',
          'DONE': 'Stap voltooid',
          'LOCK': 'Heropen stap',
          'UNLOCK': 'Stap in het proces',
        },
        'TABS': {
          'TAB1': 'NPS',
          'TAB2': 'Vertaling',
          'TAB3': 'Preview',
        }
      },
      'REACTIVOS': {
        'CONFIGURE_QUESTION': 'Druk hier om het reagens weer te geven',
        'ADD': 'Maak een statement',
        'QUESTIONUPDATEDOK': 'Verklaring met succes bijgewerkt',
        'STATUS': {
          'PEND': 'Volledige stap',
          'DONE': 'Stap voltooid',
          'LOCK': 'Heropen stap',
          'UNLOCK': 'Stap in het proces',
        },
        'TABS': {
          'TAB1': 'Verklaringen',
          'TAB2': 'Vertaling',
          'TAB3': 'Preview',
        }
      },
      'CONTROL': {
        'CONFIGURE_QUESTION': 'Klik hier om de controlevraag weer te geven',
        'ADD': 'Maak een statement',
        'QUESTIONUPDATEDOK': 'Controlevraag succesvol bijgewerkt',
        'STATUS': {
          'PEND': 'Volledige stap',

          'DONE': 'Stap voltooid',
          'LOCK': 'Heropen stap',
          'UNLOCK': 'Stap in het proces',
        },
        'TABS': {
          'TAB1': 'Controlevraag',
          'TAB2': 'Vertaling',
          'TAB3': 'Preview',
        }
      },
      'DEMOGRAFICOS': {
        'NOINFO': 'Geen informatie beschikbaar',
        'TAB1': 'Demografisch',
        'TAB2': 'Vertaling',
        'TAB3': 'Preview',
        'COMPLETAR_PASO': 'Volledige stap',
        'PASO_COMPLETADO': 'Stap voltooid',
        'SELECT': 'Selecteer een optie',
        'BTN_DEMOGRAFICOS': 'Accepteren',
        'OPTION_SURVEY': 'Enquête',
        'OPTION_EXCEL': 'Excel',
        'OPTION_AMBOS': 'Beide',
        'CLAVE': 'Rowkey',
        'RESPONSE_NOT_ADDED': 'U kunt geen antwoorden op een open vraag toevoegen',
        'CONFIGURE_QUESTION': 'Klik hier om de vraag te tonen',
        'QUESTION': 'Vraag',
        'OPCIONES_RESPUESTA': 'Response options',
        'STATUS': {
          'PEND': 'Volledige stap',
          'DONE': 'Stap voltooid',
          'LOCK': 'Heropen stap',
          'UNLOCK': 'Stap in het proces',
        },
        'EXPANSION':{
          'Work Responsability' : 'Work Responsability',
          'Trust Level': 'Vertrouwensniveau',
          'Innovation': 'Innovatie',
         'Disabilities' : 'Gehandicapten',
          'Ethnic Group' : 'Etnische Groep',
          'Personal Responsabilities' : 'Persoonlijke verantwoordelijkheden',
         ' Gender': 'Geslacht',
         ' Work Location': 'Werklocatie',
          'Travel' : 'Reizen',
          'Living Location': 'Levende Locatie',
         'Marital Status': 'Burgerlijke staat',
          'Home Type' : 'Home Type',
          'Home Location': 'Thuislocatie',
          'Home Status': 'Thuisstatus',
          'Transport' : 'Transport',
          'Sport' : 'Sport',
          'Weight' : 'Gewicht',
          'Sleep' : 'Slaap',
          'Home Office' : 'Home Office',
          'Languages' : 'Talen',
          'Work Experience': 'Werkervaring',
          'Social Networks': 'Sociale netwerken',
          'Employ Opportunities':'Werknemersmogelijkheden',
          'Inspiration' : 'Inspiratie',
          'Meetings' : 'Vergaderingen',
          'Tenure' : 'Tenure',
          'Clave': 'Rowkey',
          'Ege': 'Ege',
          'Work Status': 'Werkstatus',
          'Education': 'Onderwijs',
          'Hierarchical Level': 'Hiërarchisch niveau',
          'Confidence Decisions': 'Vertrouwensbeslissingen',
          'Work Innovation': 'Werkinnovatie',
          'Belong': 'Belong',
          'Converse Performance': 'Converse Performance',
          'Work Years': 'Werkjaren',
          'Generation': 'Generatie',

          'Confidence In Decisions': 'Vertrouwen in beslissingen',
          'Develop New Things': 'Nieuwe dingen ontwikkelen',
          'Reason To Stay': 'Reden om te blijven',
          'Age': 'Leeftijd',
         'Type Of Job': 'Soort baan',
          'Minoritate': 'Minoritate',
          'Sindicat': 'Sindicat',
          //TURQUIA//
          'Confidence': 'Vertrouwen',
          'Opportunities': 'Kansen',
          'Managerial Level': 'Managerniveau',
          'Years Of Service': 'Jaren van dienst',
          'Ethnic': 'Etnisch',
          //CAYC//
          'Hierarchical Leve': 'Hiërarchische Leve',
          'Disability': 'Invaliditeit',
          'Responsibility': 'Verantwoordelijkheid',
          'LGBT': 'LGBT',

          //BRASIL
          'Permanência': 'Permanentie',
          'Reuniões': 'Vergaderingen',
          'Motivo para ficar': 'Reden om te blijven',
          'Casa': 'Huis',
          'Nível de confiança': 'Vertrouwensniveau',
          'Oportunidades': 'Kansen',

          //ESPAÑA
          'Recommendation': 'Aanbeveling',
          'Seniority': 'Anciënniteit',
          'Contracting modality': 'Contractuele modaliteit',
          'Working': 'Werken',

          //GCTI
          'Pregunta 1': 'Vraag  1',
          'Pregunta 2': 'Vraag  2',
          'Pregunta 3': 'Vraag  3',
          'Pregunta 4': 'Vraag  4',
          'Pregunta 5': 'Vraag  5',
          'Pregunta 6': 'Vraag  6',
          'Pregunta 7': 'Vraag  7',
          'Pregunta 8': 'Vraag  8',
          'Pregunta 9': 'Vraag  9',
          'Pregunta 10': 'Vraag  10',
          'Pregunta 11': 'Vraag  11',
          'Pregunta 12': 'Vraag  12',
          'Pregunta 13': 'Vraag  13',
          'Pregunta 14': 'Vraag  14',
          'Pregunta 15': 'Vraag  15',
        }
      },
      'FORALL': {
        'MSJ_PRACTICEREGISTREERD': 'Praktijk succesvol gered',
        'SJ_DESCRIPTIONREGISTERED': 'Beschrijving succesvol opgeslagen',
        'SJ_TRANSLATEREGISTERED':'Praktijk succesvol vertaald',
        'SJ_DESCRIPTIONTRANSLATED': 'Omschrijving succesvol vertaald',
        'UESTIONUPDATEDOK': 'Vraag met succes bijgewerkt.',
        'UESTIONUPDATEDFAIL': 'Fout, voeg een geldige vraag in',
        'ESPONSEUPDATEDOK': 'Response succesvol bijgewerkt.',
        'ESPONSEUPDATEDFAIL': 'Fout, voeg een geldige antwoordtekst in',
        'RANSLATEDOK': 'Vraag vertalen met succes opgeslagen',
        'INSERTTRANSLATE': 'Gelieve de vertaling in te voegen',
        'PTIONEEL VERTAALD': 'Optie succesvol vertaald',
        'NSERTOPTIONTRANSLATE': 'Gelieve de vertaling in te voegen',
        'JS_SELECTOPTIE': 'Selecteer een optie',
        'JS_OPTIONADDED': 'Demografisch correct toegevoegd',
        'OPTIONDELETED': 'Demografisch met succes verwijderd',
        'RESPONSEOPTIONDELETED': 'Response succesvol geëlimineerd',
        'DEMOGRAPHICEXIST': 'De geselecteerde demografische gegevens bestaan reeds',
        'AGREGADEMOGRAFICO': 'Selecteer om meer demografie toe te voegen',
        'MSJ_PRACTICEREQUIRED': 'Praktijk is vereist!',
        'MSJ_DESCRIPTIONREQUIRED': 'Beschrijving is vereist!',
        'CARGANDO_PRACTICA': 'Bespaar de praktijk, wacht even...',
        'CARGANDO_DESCRIPCION': 'Beschrijving opslaan, gelieve te wachten...',
        'ACTUALIZAR_OPCION': 'Updating response, gelieve te wachten...',
        'REVISANDO_PRACTICAS': 'Controlepraktijken, gelieve te wachten...',


        'SELECCIONE': 'Selecteer een taal om de preview te tonen',
        'IDIOMAS_NOT_SELECTED': 'Extra talen zijn niet geselecteerd om te vertalen.',
        'TRANSLATE_NOT': 'U moet ten minste de naam van één praktijk en hun beschrijving schrijven',
        'PLACEHOLDER': 'Taal',
        'DESC_TRANSLATE': 'Enter description translate',
        'DESC_TRANSLATE_DEMO': 'Voer de vertaling van het antwoord in',
        'DESC_TRANSLATE_FORALL': 'Voer de vertaling van de beschrijving in',
        'PRACTICE_TRANSLATE_REACTIVOS': 'Voer de vertaling van de verklaringen in',
        'PRACTICE_TRANSLATE_ABIERTAS': 'Voer de vertaling van de open vraag in',
        'PRACTICE_TRANSLATE_FORALL': 'Voer de praktijkvertaling in',
        'PRACTICE_TRANSLATE_DEMO': 'Voer de vertaling van de demografische gegevens in',
        'IDIOMAS': {
          'Native': 'Native',
          'es': 'Spanish',
          'zh1': 'Traditional Chinese',
          'zh2': 'Simplified Chinese',
          'pt': 'Portuguese',
          'en': 'English',
          'vi': 'Vietnamese'
        },
        'RESPUESTAS': {
          'Native': 'Nativo',
          'es':{'si': 'Sí',
          'no':'No',
          'casifalso':'Casi siempre es falso',
          'false': 'Frecuentemente es falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Frecuentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'zh1':{'si': '有','no':'沒有',
          'casifalso':'從來不是這樣',
          'false': '經常不是這樣',
          'avecesfalse': '有時是有時不是',
          'casiverdad': '經常是這樣',
          'verdad': '總是這樣'},
          'zh2':{'si': '有','no':'没有',
          'casifalso':'从来不是这样',
          'false': '经常不是这样',
          'avecesfalse': '有时是有时不是',
          'casiverdad': '经常是这样',
          'verdad': '总是这样'},
          'pt':{'si': 'Si','no':'não',
          'casifalso':'Casi siempre es falso',
          'false': 'Freqüentemente é falso',
          'avecesfalse': 'A veces es falso / A veces es verdad',
          'casiverdad': 'Freqüentemente es verdad',
          'verdad': 'Casi siempre es verdad'},
          'en':{'si': 'Yes','no':'No',
          'casifalso':'Almost always untrue',
          'false': 'Often untrue',
          'avecesfalse': 'Sometimes untrue/ sometimes true',
          'casiverdad': 'Often true',
          'verdad': 'Almost always true'},
          'tr':{'si': 'Evet','no':'HAYIR',
          'casifalso':'Neredeyse her zaman yanlış',
          'false': 'Sık sık yanlış',
          'avecesfalse': 'Bazen doğru olmayan / bazen doğru',
          'casiverdad': 'Genellikle doğru',
          'verdad': 'Neredeyse her zaman doğru'},
          'jp':{'si': 'はい','no':'番号',
          'casifalso':'ほとんど常に当てはまらない',
          'false': 'しばしば当てはまらない',
          'avecesfalse': '時には当てはまらない／時には当てはまる',
          'casiverdad': 'しばしば当てはまる',
          'verdad': 'ほとんど常に当てはまる'},

          'vi':{'si': 'Đúng','no':'Không',
          'casifalso':'Nó gần như luôn luôn là sai',
          'false': 'Nó thường sai',
          'avecesfalse': 'Đôi khi nó là hàng giả / Đôi khi nó đúng',
          'casiverdad': 'Nó thường đúng',
          'verdad': 'Nó gần như luôn luôn đúng'}
        },
        'STATUS': {
          'PEND': 'Volledige stap',
          'DONE': 'Stap voltooid',
          'LOCK': 'Heropen stap',
          'UNLOCK': 'Stap in het proces',
        },
        'TABLA': {
          'TITULOS': {
            'DEFAULT': 'Hoofdtaal',
            'TRADUCCION': 'Vertalingen',
            'PREVIEW': 'Preview'
          },
          'ENCABEZADOS': {
                      'PRACT': 'Praktijknaam',
                      'DESCR': 'Beschrijving',
                      'STT1': 'Verklaring 1',
                      'STT2': 'Verklaring 2',
                      'LANG': 'Taal'
                    },
                    'INPUTS': {
                      'PRACTIE': 'Voer de naam van de praktijk in',
                      'DESCR': 'Voer de beschrijvingstekst in'
                    }
                  }
                },
                'ABIERTAS': {
                  'STATUS': {
                    'PEND': 'Volledige stap',
                    'DONE': 'Stap voltooid',
                    'LOCK': 'Heropen stap',
                    'UNLOCK': 'Stap in het proces',
                  },
                  'TABS': {
                    'TAB1': 'Open vragen',
                    'TAB2': 'Vertaling',
                    'TAB3': 'Preview',
                  }
                },
      'ADICIONALES': {
        'FOCUS':{
          'ENVIO-AUTORIZACION': 'Verzonden naar een vergunning',
          'AUTORIZACION-OK': 'Uw enquête is geautoriseerd, ga verder met het voltooien van de stap',

        },
        'STATUS': {
          'PEND': 'Volledige stap',
          'DONE': 'Stap voltooid',
          'LOCK': 'Heropen stap',
          'UNLOCK': 'Stap in het proces',
        },
        'TABS': {
          'QUESTIONS': 'Aanvullende vragen',
          'TRANSLATE': 'Vertaling',
          'PREVIEW': 'Preview'
        },
        'PREGUNTAS':{
          'STATUS': {
            'SIN': 'U heeft geen extra vragen gemaakt',
            'CON': 'Vragen gesteld:',
            'NOADICIONALES': 'U kiest ervoor geen extra vragen aan te maken',
            'CANCELNOADIC': 'U heeft de optie om geen extra vragen te maken geannuleerd',
            'ERROR': 'Er is een fout opgetreden tijdens het uitvoeren van de handeling'
          },
          'ACCIONES': {
            'ADD': 'Maak een vraag',
            'SIN': 'De enquête heeft geen aanvullende vragen'
          },
          'WIZARD': {
            'NEW': 'Nieuwe vraag',
            'TIPOTITU': 'Klik hier om de aanvullende vraag te configureren',
            'TIPO': {
              'OPEN': 'Open vraag',
              'UNI': 'Vraag over één enkele optie',
              'MULT': 'Meervoudige optie vraag',
              'MULTLIKERT3-1': 'Vraag op 3 like-schaal',
              'MULTLIKERT5-1': 'Vraag op 5 like-schaal',
              'TITULOLIKERTSIMPLE': 'Vraag op vergelijkbare schaal',
              'MULTLIKERT-MUL': 'Vraag op like-schaal Multiple',

            },
            'FORM': {
              'TIPO': 'Type vraag',
              'TOOLTIP': {
                'REMOVE': 'Verwijder deze vraag'
              },
              'MENSAJES': {
                'BORRAR': 'Wilt u deze aanvullende vraag verwijderen?',
                'PREG_OK': 'De vraag is succesvol opgeslagen',
                'PREG_ERR': 'Er is een fout opgetreden tijdens het opslaan van de vraag',
                'PREG_MOD_OK': 'De vraag is correct aangepast',
                'PREG_MOD_ERR': 'Er is een fout opgetreden bij het wijzigen van de vraag',
                'OPC_OK': 'De antwoordoptie is succesvol opgeslagen',
                'OPC_ERR': 'Er is een fout opgetreden tijdens het opslaan van de antwoordoptie',
                'OPC_MOD_OK': 'De antwoordoptie is correct aangepast',
                'OPC_MOD_ERR': 'Er is een fout opgetreden bij het wijzigen van de antwoordoptie',
                'PREG_DEL_OK': 'De vraag is met succes verwijderd',
                'PREG_DEL_ERR': 'Er is een fout opgetreden bij het verwijderen van de vraag',
                'OPC_DEL_OK': 'De antwoordoptie is met succes verwijderd',
                'OPC_DEL_ERR': 'Er is een fout opgetreden bij het verwijderen van de antwoordoptie'
              },
              'BOTONES':{
                'SI': 'Ja',
                'NO': 'Nee'
              }
            },
            'ABIERTA': {
              'TITULO': 'Nieuwe open vraag',
              'ACCION': 'Voer de vraagtekst in',
              'ERROR': 'U hebt de vraagtekst niet ingevuld',
            },
            'MULTI':{
              'TITULOSING': 'Nieuwe vraag over één enkele optie',
              'TITULOMULT': 'Nieuwe meerkeuzevraag',
              'TITULOLIKERT3': 'Nieuwe vraag in like-schaal: 3',
              'TITULOLIKERT5': 'Nieuwe vraag in like-schaal: 5',
              'TITULOLIKERTSIMPLE': 'Nieuwe eenvoudige vraag in like-schaal',
              'ACCION': 'Voer de vraagtekst in',
              'ERROR': 'U hebt de vraagtekst niet ingevuld',
              'MENSAJES': {
                'BORRAR': 'Wilt u deze antwoordmogelijkheid verwijderen?',
                'SINPREG': 'U kunt geen enkele optie invoeren tot u de vraagtekst invoert',
                'SINANTE': 'U kunt deze antwoordoptietekst pas invoeren als u de vorige antwoordoptietekst invoert',
                'WARN-2-1': 'U kunt slechts 2 antwoordkeuzes invoeren',
                'WARN-3-1': 'U kunt slechts 3 antwoordkeuzen invoeren',
                'WARN-5-1': 'U kunt slechts 5 antwoordkeuzen invoeren',
                'WAARSCHUWING-NOET-NUMMER': 'U kunt alleen getallen invoeren',
                'ETIQUET-VALOR': 'Waarde',
              },
              'OPCIONES': {
                'TITU': 'Beantwoordingsopties',
                'INPUT': {
                  'TITU': 'Antwoordmogelijkheid',
                  'ERRO':'U hebt de tekst voor de antwoordoptie niet ingevul'
                }
              },
              'TOOLTIP': {
                'ADD': 'Voeg een antwoordmogelijkheid toe',
                'MOVE': 'Verplaats de antwoordoptie',
                'REMOVE': 'Verwijder deze antwoordmogelijkheid'
              }
            }
          }
        },
        'TRADUCCIONES': {
          'TITULO': 'Selecteer een taal om de vertaalde teksten in te voeren',
          'TITULOALTERNO': 'U hebt geen extra taal geselecteerd in de rubriek Talen',
          'NOTYET': 'Vertaling nog niet voltooid.',
          'MAIN': 'Hoofdtaal',
          'INPUT': {
            'NEW': 'Voer de vertaling van de vraag in',
            'ERROR': 'U hebt de vertaling van de vraag niet ingevuld!',
            'NEWOPC': 'Voer de vertaling van de antwoordoptie in',
            'ERROROPC': 'U hebt de vertaling van de antwoordoptie niet ingevoerd!'
          },
          'MENSAJES': {
            'PREG_OK': 'De vertaalde tekst is succesvol opgeslagen',
            'PREG_ERR': 'Er is een fout opgetreden tijdens het opslaan van de vertaalde tekst',
            'PREG_MOD_OK': 'De vertaalde tekst is correct bijgewerkt',
            'PREG_MOD_ERR': 'Er is een fout opgetreden tijdens het bijwerken van de vertaalde tekst',
            'OPC_NOPREG': 'De vertaaltekst voor deze optie kan niet worden opgeslagen totdat de vraagtekst is ingesteld',
            'OPC_OK': 'De vertaalde tekst is succesvol opgeslagen',
            'OPC_ERR': 'Er is een fout opgetreden bij het opslaan van de vertaalde tekst',
            'OPC_MOD_OK': 'De vertaalde tekst werd correct geüpdatet',
            'OPC_MOD_ERR': 'Er is een fout opgetreden tijdens het bijwerken van de vertaalde tekst',
            'TRADUC_PREGUNT': 'De vertaling van de vraag wordt bewaard...',
            'TRADUC_MOD_PREGUNT':'De vertaling van de vraag wordt bijgewerkt...',
            'TRADUC_OPC':'De vertaling van de optie wordt opgeslagen...',
            'TRADUC_MOD_OPC': 'De vertaling van de optie wordt bijgewerkt...',
            'VALOR_OK':'De waarde van de optie wordt correct opgeslagen',
            'VALOR_MOD_OK': 'De waarde van de optie is correct bijgewerkt',
          },
          'COMPLETE': 'Vertaling compleet '
        },
        'PREVIEW': {
          'TITULO': 'Selecteer een taal om de bijkomende vragenvertalingen te tonen',
          'SINPREV': 'Er zijn geen vertaalde teksten voor de geselecteerde taal',
          'LADING': 'Laadgegevens',
          'INPUT': {
            'RESPABIERTA': 'Schrijf je antwoord',
            'ERRORABIERTA': 'Je hebt je antwoord niet geschreven!',
            'ELIGELANG': 'Kies een taal'
          },
          'HELP': {
            'SINGLE': 'U mag alleen een optie in deze vraag kiezen',
            'MULTI': 'U kunt in deze vraag meer dan één optie kiezen',
            'FALTA': 'De vertaalde tekst is niet ingevoerd!'
          }
        }
      },
      'COLABORADORES': {
        'STATUS': {
          'PEND': 'Volledige stap',
          'DONE': 'Stap voltooid',
          'LOCK': 'Heropen stap',
          'UNLOCK': 'Stap in het proces',
        },
        'STATUSBAR': {
          'NOBD': 'U heeft uw deelnemersdatabank niet geladen',
          'PROCES': 'De deelnemersdatabank is nog niet opgeslagen',
          'ERROR': 'Er werden fouten gevonden in het geladen bestand',
          'OK': 'De deelnemersdatabase is correct opgeslagen'
        },
        'CARD_BD': {
          'TITULO': 'Informatie',
          'NUMCOLABS': 'Aantal deelnemers',
          'FECHA': 'Laatste uploaddatum:',
          'TITULO_PRE': 'Uploadgeschiedenis:',
          'TITULO_PRE_2': 'Gebruikers',
          'ACCIES': 'Acties',
          'WANNADO': 'Wat wil je doen?',
          'BOTONES': {
            'DESCARGA': 'Download de deelnemersdatabase',
            'ELIMINA': 'Verwijder de deelnemersdatabank',
            'VER': 'Zie deelnemerslijst'
          }
        },
        'CARD_NOBD': {
          'TITULO': 'Volg deze stappen om de informatie van je deelnemers te uploaden in Cultural GO®',
          'PASOS': {
            '1': 'Download het sjabloon van de deelnemersdatabank',
          '2': 'Vul het sjabloon met uw deelnemersgegevens op basis van de verstrekte kolommen',
          '3': 'Upload het bestand met uw deelnemersgegevens'
          },
          'TOOLTIP': 'Dit bestand bevat gegevensvalidatiemacros',
        'FILE': 'Collaborators List Template file',
        },
        'CARD_NOERR': {
          'TITULO': 'Informatie',
          'NUMCOLABS': 'Aantal deelnemers aan het geladen bestand',
          'FILENAME': 'Naam van het bestand',
          'GUARDAR': 'Wil je deze informatie opslaan?',
          'BOTONES': {
            'SI': 'Ja',
            'NO': 'Nee'
          }
        },
        'CARD_ERRFND': {
          'TITULO': 'Informatie',
          'ROWS_OK': 'Aantal juiste rijen',
          'ROWS_NOTOK': 'Aantal rijen met fouten',
          'MOREINFO': '* De foutenlijst is hieronder in detail weergegeven',
          'FILENAME': 'Naam van het bestand',
          'GUARDAR': 'De geladen informatie kan niet worden opgeslagen',
          'DELETE': 'Delete file'
        },
        'CARD_ERRLIST': {
          'TITULO': {
            '1': 'Rijen met fouten: ',
            '2': 'Totaal aantal geconstateerde fouten:',
          },
          'INFO': {
            'ROW': 'Rij',
            'ERRNUM': 'Aantal fouten: ',
            'SHOW': 'Klik hier om deze rijfouten te tonen',
          },
          'DETALLE': {
            'TIPO': 'Type fout',
            'DESCR': 'Beschrijving',
            'COLUMNA': 'Kolom',
            'DATO': 'Verkeerde gegevens'
          },
          'ERRORES': {
            'alfabetica': 'Alfabetische ongeldige gegevens',
            'alfanumerica': 'alfanumerieke ongeldige gegevens',
            'numerica': 'Numerieke ongeldige gegevens',
            'E-mail': 'E-mail ongeldige syntaxis',
            'vacio': 'Lege cel',
            'columnna': 'Onbekende kolom',
            'catSurvey': 'Onbekende gegevens',
            'repetido': 'Herhaalde gegevens',
            'sameKey': 'Dezelfde bossleutel',
            'NoCeo': 'CEO niet gevonden',
            'BaaskeyNotFnd': 'BaaskeyNotFnd niet gevonden',
            'continuidad': 'Continuïteit in niveaus',
            'nivelRepetido': 'Herhaalde informatie',
            'multiceo': 'Meerdere CEO',
            'age': 'Verkeerd geboortejaar',
            'seccionSinUsar': 'Speciale sectiesleutel niet gebruikt',
            'date': 'ongeldige datum',
            'listOption': 'Foutieve informatie',
            'dateFuture': 'Datum niet toegestaan'
          },
          'DESCRIPCION': {
            'alfabetica': 'De informatie heeft een of meer ongeldige tekens. Alleen alfabetische tekens (A - Z) en de volgende speciale tekens: [( ) . , : -] zijn toegestaan ',
            'alfanumerica': 'De informatie heeft een of meer ongeldige tekens. Alleen alfabetische tekens (A - Z), numerieke (0 - 9) en de volgende speciale tekens: [( ) . , : -] zijn toegestaan ',
            'numerica': 'De informatie heeft een of meer ongeldige tekens. Alleen numerieke tekens (0 - 9) zijn toegestaan',
            'e-mail': 'De informatie heeft niet de juiste e-mailsyntax ( mail@domain.com )',
            'vacio': 'De cel heeft geen informatie Deze kolom is verplicht.',
            'columna': 'De kolom behoort niet tot het door CULTURAL GO® geleverde sjabloon',
            'catSurvey': 'De celinformatie komt niet overeen met een optie die is ingevoerd in het onderdeel Demografie van het platform',
            'repetido': 'Deze cel heeft herhaalde informatie van een andere cel in dezelfde kolom. Herhaalde gegevens zijn niet toegestaan in deze kolom.',
            'sameKey': 'Deze rij heeft dezelfde informatie in deze kolom: \nEMPLOYEE NUMBER\nDIRECT BOSS NUMBER dit is niet toegestaan',
            'NoCeo': 'De CEO informatie is niet gevonden in de lijst van medewerkers, het moet worden gespecificeerd met het EMPLOYEE NUMBER als 0 om verder te gaan',
            'bosskeyNotFnd': 'De sleutel van de baas in deze cel is niet in verband gebracht met een medewerker op de lijst',
            'continuidad': 'De continuïteit van de niveaus in deze cel werd onderbroken, de niveaus moeten continu zijn',
            'nivelRepetido': 'De informatie in deze cel werd herhaald met de informatie die overeenkomt met het vorige niveau, dit is niet toegestaan',
            'multiceo': 'Er is meer dan één bijdrager aangegeven als CEO gevonden, het is toegestaan om slechts één bijdrager in het bestand als CEO aangegeven te hebben ',
            'age': 'Het ingevoerde geboortejaar moet uit vier cijfers bestaan',
            'seccionSinUsar': 'Er is ten minste één speciale sectiesleutel gevonden die niet werd gebruikt in de lijst met bijdragers. Alle toetsen voor speciale secties moeten door ten minste één bijdrager worden gebruikt',
            'date': 'De ingevoerde informatie heeft niet het juiste datumformaat',
            'listOption': 'De ingevoerde informatie komt niet overeen met de opties die door de sjabloon worden geboden. Slechts één van de standaardopties is toegestaan in deze cel',
            'dateFuture': 'De datum die in de cel is ingevoerd, komt overeen met een datum na de huidige dag. Het is alleen toegestaan om een datum voor de huidige dag in te voeren'
          }
        },
        'CARD_LOAD': {
          'CARGA': {
            'TITULO': 'Laden',
            'INFO': 'Analyse van de bestandsinformatie, wacht even a.u.b.'
          },
          'GUARDA': {
            'TITULO': 'Saving',
            'INFO': 'Informatie opslaan in het systeem, blijf in dit scherm totdat het opslaan is voltooid'},
        },
        'MENSAJES': {
          'GUARDA_1': 'Bevestigt u dat u de informatie van ',
          'GUARDA_2': 'deelnemers?',
          'GUARDADO': 'De deelnemersdatabase is met succes opgeslagen',
          'GUA_ERR': 'Er is een fout opgetreden tijdens het opslaan van de informatie. Probeer het later nog eens',
          'NODELETE': 'U kunt de database niet verwijderen als de eamails naar uw medewerkers zijn gestuurd',
          'DELETE_1': 'Bevestigt u dat u de informatie van ',
          'DELETE_2': 'medewerkers?',
          'DEL_OK_1': 'De informatie van ',
          'DEL_OK_2': ' medewerkers werden met succes verwijderd',
          'DEL_ERR': 'Er is een fout opgetreden bij het verwijderen van de database van medewerkers. Probeer het later nog eens',
          'DEL_ERR_EMA_SEN': 'Deze actie is niet mogelijk omdat de e-mails zijn verzonden',
          'VERTROUWELIJKHEID': 'Het bestand van de deelnemersdatabank is op de juiste wijze verwijderd',
          'EXCEL': 'Excel-bestand genereren, wacht even a.u.b.',
          'EXTMAL': 'Het geselecteerde bestand heeft niet de juiste extensie. Alleen het uploaden van het door CULTURAL GO® geleverde sjabloonbestand is toegestaan',
          'NOROWS': 'Het geselecteerde bestand heeft geen record',
          'VACIO': 'Het geselecteerde bestand is leeg, of de gegevens van de medewerkers staan niet op het eerste blad',
          'VERSIONANTERIOR': 'Het geselecteerde bestand komt overeen met een eerdere versie van de lijst met bijdragers, download de meest recente versie, upload de informatie van uw bijdragers in dat bestand en upload de lijst opnieuw',
          'BROKERINCORRECTO': 'Het geselecteerde bestand komt niet overeen met de versie van de broker waartoe het bedrijf behoort, download de sjabloon opnieuw, upload de informatie van uw medewerkers in dat bestand en upload de lijst opnieuw',
          'BOTONES': {
            'SI': 'ja',
            'NO': 'Neen'
          }
        },
        'EXCELINFO': {
          'HOJA': 'Gegevens van de medewerkers',
          'TITULO': 'Collaboratorsdatabank',
          'AUTORITEITEN': 'CULTURAL GO®',
          'ASUNTO': 'Gedownload van platform'
        },
        'UPLOAD': 'Klik hier om door de deelnemersdatabase te bladeren',
        'REMOVE': 'Verwijder van de upload',
        'SEND': 'Stuur naar de database',
        'PROCESO': {
          'STP1': 'Analyse van de database van medewerkers',
          'STP2': 'Opslaan van de database van medewerkers',
        },
        'ALERT_COLAB': 'Gebruikers zullen worden weergegeven in de enquête zodra deze stap is gemarkeerd als voltooid',
        'MODAL_ERROR': {
          'TITULO': 'Fouten gevonden in het bestand',
          'TOTAL_ERRORES_1': 'Fouten gevonden in het bestand',
          'TOTAL_ERRORES_2': '<b> meer dan 100 </b> fouten gevonden in het bestand',
          'INFO_1': 'Het aantal en type specifieke fouten wordt hieronder in detail weergegeven',
          'INFO_2': '<b> OPMERKING: </b> het proces kan alleen doorgaan als het bestand geen fouten bevat, bij het sluiten van dit venster wordt het proces opnieuw gestart. Breng de nodige correcties aan in het bestand en laad het opnieuw',
          'TABLA_RESUMEN': {
            'TIPO': 'Soort fout',
            'TOTAL': 'Totaal aantal fouten',
            'ACCIONES': 'Acties',
            'MASINFO': 'Meer informatie',
            'VERMAS': 'Bekijk fouten'
          },
          'TABLA_LISTA': {
            'TOTAL_1': 'Weergegeven fouten',
            'TOTAL_2': 'Fouten niet weergegeven',
            'INFO': 'Fouten die niet worden weergegeven, zijn qua kenmerken vergelijkbaar met de weergegeven fouten',
            'FILA': 'Rij',
            'COLUMNA': 'Kolom',
            'DATO': 'Verkeerde data'
          },
          'BOTONES': {
            'REGRESAR': 'Ga terug',
            'CONTINUAR': 'Doorgaan met'
          }
        }
      }
    }
  }
};
